import { OrderLineRefundStatus, OrderTicketAdmissionStatus, TicketTypeType } from '@vista-digital/ocapi-types/v1';
import { addMonetaryValues } from '../../../utils/monetary-value-utils';
/**
 * Returns true if all tickets for a showtime have been refunded.
 */
export const hasOrderShowtimeBeenFullyRefunded = (showtime) => {
    return showtime.tickets.every(ticket => ticket.refundStatus === OrderLineRefundStatus.Refunded);
};
/**
 * Returns true if all tickets for a showtime have been admitted.
 */
export const hasOrderShowtimeBeenFullyAdmitted = (showtime) => {
    return showtime.tickets.every(ticket => {
        if (ticket.type === TicketTypeType.Package) {
            return ticket.tickets.every(t => t.admissionStatus === OrderTicketAdmissionStatus.Admitted);
        }
        return ticket.admissionStatus === OrderTicketAdmissionStatus.Admitted;
    });
};
export const calculateBookingFeeForShowtime = (showtime) => addMonetaryValues(...showtime.tickets.map(ticket => { var _a; return (_a = ticket.bookingFee) === null || _a === void 0 ? void 0 : _a.amount; }));
export const getNonRefundedOrderTicketLinesForShowtime = (showtime) => {
    return showtime.tickets.filter(t => t.refundStatus === OrderLineRefundStatus.NotRefunded);
};
export const getRefundedOrderTicketLinesForShowtime = (showtime) => {
    return showtime.tickets.filter(t => t.refundStatus === OrderLineRefundStatus.Refunded);
};
